import { MOKA_SERVICE_HOST } from '../constants';

const MOKA_PARTNER_SERVICE = `${MOKA_SERVICE_HOST}/partner`;

export const PARTNER_GOBIZ_OAUTH_TOKEN = `${MOKA_PARTNER_SERVICE}/v1/partners/gobiz/oauth2/token`;

export const PARTNER_GOBIZ_TOKEN_BY_OUTLET_ID = (outletId) => {
  return `${MOKA_PARTNER_SERVICE}/v1/partners/gobiz/outlets/${outletId}/token`;
};

export const PARTNER_GET_PARTNERS = `${MOKA_PARTNER_SERVICE}/v1/partners`;

export const PARTNER_GET_PARTNER_DETAIL = (partnerId) => {
  return `${MOKA_PARTNER_SERVICE}/v1/partners/${partnerId}`;
};

export const PARTNER_REGISTER_MERCHANT_CONSENT = (partnerId) => {
  return `${MOKA_PARTNER_SERVICE}/v1/partners/${partnerId}/register`;
};

export const PARTNER_UNREGISTER_MERCHANT_CONSENT = (partnerId) => {
  return `${MOKA_PARTNER_SERVICE}/v1/partners/${partnerId}/unregister`;
};
